import { Button, Col, Row } from '@oscar/theme';
import { APIS } from 'common/constants/endpoints';
import { useState, useEffect } from 'react';
import apiClient from '@oscar/request';
import { STATISTIC, STATUS_COLOR_TABLE } from 'common/constants';

export const BubbleComponent = () => {
  const [data, setData] = useState<any>();
  useEffect(() => {
    apiClient
      .request({ method: 'GET', url: APIS.SCAFFOLD_COUNT })
      .then(res => setData(res));
    // apiClient
    //   .request({
    //     method: 'POST',
    //     url: APIS.EXPORT_DATA_REQUEST,
    //     responseType: 'blob',
  }, []);
  return (
    <div style={{ marginTop: '10px', marginBottom: '10px' }}>
      <Row gutter={24} style={{ marginBottom: '10px' }}>
        <Col span={4}>
          <Bubble
            total={data?.numPendingValidation}
            title={'Pending Validation'}
          />
        </Col>
        <Col span={4}>
          {' '}
          <Bubble total={data?.numPendingProposal} title={'Pending Proposal'} />
        </Col>
        <Col span={4}>
          <Bubble total={data?.numPendingErection} title={'Pending Erection'} />
        </Col>
        <Col span={4}>
          <Bubble
            total={data?.numPendingInspection}
            title={'Pending Inspection'}
          />
        </Col>
        <Col span={4}>
          <Bubble
            total={data?.numPendingDismantlement}
            title={'Pending Dismantlement'}
          />
        </Col>
        <Col span={4}>
          <Bubble total={data?.numBilling} title={'Billing'} />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={4}>
          <Bubble total={data?.numInService} title={'In-service'} />
        </Col>
        <Col span={4}>
          <Bubble total={data?.numOutofService} title={'Out of Service'} />
        </Col>
        <Col span={4}>
          <Bubble total={data?.numClosed} title={'Closed'} />
        </Col>
        <Col span={4}>
          <Bubble total={data?.numDraft} title={'Draft'} />
        </Col>
        <Col span={4}>
          <Bubble total={data?.numCancelled} title={'Cancelled'} />
        </Col>
      </Row>
    </div>
  );
};

type BubbleProps = {
  total: number;
  title: string;
};

const Bubble = ({ total, title }: BubbleProps) => {
  let color = '#677C91';
  let backgroundColor = '#9FB0C2';
  STATUS_COLOR_TABLE?.map(item => {
    if (item.STATUS_LABEL === title) {
      color = item.COLOR;
      backgroundColor = item.BACKGROUND_COLOR;
    }
  });
  return (
    <div
      style={{
        backgroundColor: backgroundColor,
        color: color,
        padding: '5px',
        width: '200px',
        border: `solid 1px ${backgroundColor}`,
        borderRadius: '5px',
        display: 'flex',
      }}
    >
      <span>
        <div style={{ fontWeight: 'bolder' }}>{total}</div>
      </span>
      <span style={{ width: '10px' }}></span>
      <span>
        <div style={{ fontWeight: 'bold' }}>{title}</div>
      </span>
    </div>
  );
};
